import { z } from "zod";
import env from "@/app/config/env";

export const MarketplaceCartItemSchema = z.object({
  Id: z.number(),
  BaseAmount: z.number().optional(),
  CostId: z.string().optional(),
  CostStripeId: z.string().optional(),
  CostUnit: z.string().optional(),
  Count: z
    .number()
    .optional()
    .transform((value) => value || 0),
  Currency: z.string().optional(),
  ProductDescription: z.string().optional(),
  ProductShortDescription: z.string().optional(),
  ProductId: z.string().optional(),
  ProductImage: z
    .string()
    .optional()
    .transform((value) => (value ? `${env.hosts.image}/${value}` : "")),
  ProductName: z.string().optional(),
  // Trial/free flags are dropped from the JSON when false/null
  // (Newtonsoft DefaultValueHandling.Ignore), so they must stay optional.
  ProductHasTrial: z.boolean().optional(),
  TrialMonths: z.number().optional(),
  ProductNotForSale: z.boolean().optional(),
  ProductStripeId: z.string().optional(),
  ProductType: z.string().optional(),
  ProductUrl: z.string().optional(),
  TotalAmount: z
    .number()
    .optional()
    .transform((value) => value || 0),
  TotalItemsAmount: z
    .number()
    .optional()
    .transform((value) => value || 0),
});

export type MarketplaceCartItemType = z.infer<typeof MarketplaceCartItemSchema>;
